import React, { useEffect, useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import ButtonAuth from '../trigger_auth/buttonAuth/ButtonAuth';
import HeaderNav from '../trigger_auth/headerNav/HeaderNav';
import AlertTriggerLogin from '../trigger_auth/alertTrigger/AlertTrigger';
import { SegurosPromoIcon, Help } from '../../assets/icons/index';
import useCurrentUser from '../../hooks/useCurrentUser';

const Header = () => {
  const { user, isLoading, refetch } = useCurrentUser();

  const [modalOpen, setModalOpen] = useState(false);

  const dialogRef = useRef(null);

  useEffect(() => {
    if (modalOpen && dialogRef.current) {
      dialogRef.current.showModal();
    } else if (dialogRef.current) {
      dialogRef.current.close();
    }
  }, [modalOpen]);

  const handleOpenMenu = () => setModalOpen(true);
  const handleCloseMenu = () => setModalOpen(false);

  return (
    <div className="comp_header">
      <div className="container">
        <div className="comp_header_logo">
          <a href="/" className="logo">
            <SegurosPromoIcon size={199} />
          </a>
        </div>
        <div className="comp_header_safe-area" id="safearea">
          <a href="/atendimento/">Ajuda</a>
          <ButtonAuth user={user} isLoadingUser={isLoading} refetchUser={refetch} />
        </div>

        <div className="container-menu-mobile">
          <ButtonAuth
            mobile={true}
            onOpenMenu={handleOpenMenu}
            user={user}
            isLoadingUser={isLoading}
            refetchUser={refetch}
          />
        </div>
        <dialog ref={dialogRef} className="comp_header_menu_container" tabIndex="-1" id="comp_header_menu_modal">
          <div className="comp_header_menu_head">
            <a href="/" className="logo">
              <SegurosPromoIcon />
            </a>
            <ButtonAuth
              mobile={true}
              close={true}
              onOpenMenu={handleCloseMenu}
              user={user}
              isLoadingUser={isLoading}
              refetchUser={refetch}
            />
          </div>

          <div className="comp_header_menu_content">
            <div className="comp_header_menu_content_wrapper" id="mobile-auth-content">
              {user ? (
                <HeaderNav
                  baseURL={process.env.REACT_APP_SITE_URL}
                  isAuthenticated={true}
                  isMobile={true}
                  user={user}
                />
              ) : (
                <AlertTriggerLogin
                  baseURL={process.env.REACT_APP_SITE_URL || ''}
                  authURL={process.env.REACT_APP_SAFEAREA_BACKEND_URL || ''}
                  refetchUser={refetch}
                />
              )}
              <a href="/atendimento/" class="link">
                <div>
                  <Help />
                  <span>Ajuda</span>
                </div>
              </a>
            </div>
          </div>
        </dialog>
      </div>
    </div>
  );
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/header/Header.jsx